/*
--------------------------------------------------------------------------------------------------------------
Autor:              EMANUEL GUIVAR
Fecha de creacion:  09/04/2025
Sistema:            Web seguros
Descripcion:        Pagina para web de seguros
BITACORA DE CAMBIOS 
--------------------------------------------------------------------------------------------------------------
CODIGO      REQ     ANALISTA                    FECHA       MOTIVO
(@#)1-A   SOL 33756    Emanuel Guivar           30/12/2025   Cambios fase 3 - Seguros desailiacion, siniestro y endosos
(@#)2-A	  SOL-35304   Emanuel Guivar            30/07/2026     Efectiva a Banco Efectiva
--------------------------------------------------------------------------------------------------------------
*/
import React, { useEffect } from 'react';
import FinancieraForm from '../componentes/FinancieraForm';
import Helpers from '../data/Helpers';
import useUrlQuery from '../hooks/useUrlQuery';
import ImgLogo from '../images/efectiva-logo.jpg'; 
import ImgBancoEfectiva from '../images/banner_seguroEfectibank.png'; //(@#)2-A
import './LibroEfectiva.sass';
import './../css/cssPersonalizados.css';  

const LibroEfectiva = () => {

    const fromOtherUser: string = useUrlQuery().get("origenUsuario")!;  //(@#)1-A
    const fromOtherApp = useUrlQuery().get("app");
    if (fromOtherApp) return (
        <div className="LibroEfectiva">
            <main className="LibroEfectiva-main">
                <div className="container-fluid">
                    {/*<FinancieraForm  sistem="1" /> */}
                    <FinancieraForm sistem="1" appUser={fromOtherUser} /> {/*(@#)1-A*/} 
                </div>
            </main>
        </div>
    );
    return (
        <div className="LibroEfectiva">
            {/*(@#)2-A inicio*/}
            <header className="LibroEfectiva-header mb-4 text-center">
                <img
                    src={ImgBancoEfectiva}
                    alt="Banner Desafiliacion, Siniestro y Endosos Seguros"
                    style={{ width: "1250px", height: "auto" }}
                />
            </header>
            {/*
            <header className="LibroEfectiva-header mb-4"> 
                <div className="container h-100">
                    <a href="https://www.efectiva.com.pe/" className="d-inline-block h-100">
                        <img className="d-inline align-middle" src={ImgLogo} alt="Efe" />
                    </a>
                    <div className="h-100 float-right">
                        <h1 className="d-inline align-middle font-italic">Desafiliacion, Siniestro y Endoso de Seguros </h1>
                    </div>
                    
                </div>
            </header>
            */}
            {/*(@#)2-A fin*/}
            <main className="LibroEfectiva-main">
                <div className="container">
                    {/*<FinancieraForm sistem="" /> */}     {/*(@#)1-A*/}
                    <FinancieraForm sistem="" appUser="" /> {/*(@#)1-A*/} 
                </div>
            </main>
            <footer className="LibroEfectiva-footer">
                <div className="container">
                    {/*(@#)2-A Inicio*/}
                    {/*<span>© 2025 Financiera Efectiva S.A. Todos los derechos reservados.</span>*/}
                    <span>© 2026 Banco Efectiva S.A. Todos los derechos reservados.</span>
                    {/*(@#)2-A Fin*/}
                </div>
            </footer>
        </div>
    );
};

export default LibroEfectiva;